import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAgedSettlementsReport extends Layout {
    checkboxAgent: Checkbox;
    checkboxCarriers: Checkbox;
    checkboxCompanyDriver: Checkbox;
    checkboxInclOnlyItemsWithCarrier: Checkbox;
    checkboxIncludeHoldItem: Checkbox;
    checkboxOwnerOps: Checkbox;
    checkboxPageBreakAfterManager: Checkbox;
    excludabletextboxCarrierMng: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    labelPayeeType: Label;
    panelPayeeTypes: Panel;
    sourceAgedSettlements: DataSource;
    switchGroupByCarrierManager: Switch;
    textboxCuttofDate: Textbox;
    textboxReportBy: Textbox;
    textboxReportType: Textbox;
    textboxSortBy: Textbox;
}
